import { Star, Quote } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { RATINGS, TESTIMONIALS } from "@/lib/data";

const Stars = () => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-[#489A88] text-[#489A88]" />
    ))}
  </div>
);

const Reviews = () => (
  <section id="recensioni" data-testid="reviews-section" className="bg-[#FAF8F5] py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="flex flex-wrap items-end justify-between gap-8 mb-16">
        <div>
          <Overline>05 — Dicono di Me</Overline>
          <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#1A2E2A] leading-[1.1]">
            La Fiducia dei <span className="italic text-[#489A88]">Pazienti</span>
          </h2>
        </div>
        <div className="flex gap-4">
          {RATINGS.map((r) => (
            <div
              key={r.platform}
              data-testid={`rating-badge-${r.platform.toLowerCase()}`}
              className="rounded-2xl bg-white border border-[#E2E8F0] px-6 py-4 shadow-[0_8px_30px_-16px_rgba(26,46,42,0.25)]"
            >
              <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#64748B]">{r.platform}</p>
              <p className="font-['Outfit'] text-2xl font-medium text-[#1A2E2A] mt-1">{r.score}</p>
              <p className="text-xs text-[#64748B]">{r.count}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={`${t.author}-${i}`} delay={(i % 3) * 0.1}>
            <figure
              data-testid={`review-card-${i}`}
              className="h-full rounded-[1.75rem] bg-white border border-[#E2E8F0]/70 p-8 shadow-[0_10px_40px_-24px_rgba(26,46,42,0.25)] hover:shadow-[0_24px_50px_-24px_rgba(72,154,136,0.4)] hover:-translate-y-1 transition-[box-shadow,transform] duration-500"
            >
              <div className="flex items-center justify-between mb-5">
                <Stars />
                <Quote className="w-6 h-6 text-[#B9D9D1]" />
              </div>
              <blockquote className="text-sm sm:text-base leading-relaxed text-[#4A5568]">“{t.text}”</blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[#E2E8F0]/70 flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-[#E8F5F2] text-[#2D6D60] flex items-center justify-center font-['Outfit'] font-semibold text-sm">
                  {t.author.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-[#1A2E2A]">{t.author}</p>
                  <p className="text-xs text-[#64748B]">Recensione {t.source}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Reviews;
